<div class="container_dati_generali" *ngIf="payments">
  <div class="row">
    <div class="col-12">
      <table class="table table-striped aggiunta_classiicazione">
        <caption class="sr-only">Tabella Lista Pagamenti</caption>
        <thead>
          <tr>
            <!-- <th class="col-xs-4">Ufficio</th> -->
            <th class="col-xs-4">Causale</th>
            <th class="col-xs-3">Data</th>
            <th class="col-xs-2">Importo</th>
            <th class="col-xs-1">Stato</th>
            <th class="col-xs-2">Azioni</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payment of currentPayments">
            <!-- <td class="col-xs-4 cell">{{payment.codiceDistretto}}</td> -->
            <td class="col-xs-3 cell">{{payment.causale}}</td>
            <td class="col-xs-2 cell">{{payment.dataRichiesta | date: "dd/MM/yyyy HH:mm"}}</td>
            <td class="col-xs-1 cell">{{payment.importo | currency: 'EUR'}}</td>
            <td class="col-xs-1 cell"><span [class]="getPaymentStatusIcon(payment.stato)" [title]="getPaymentStatusTitle(payment.stato)"></span></td>
            <td class="col-xs-1">
              <span class="glyphicon glyphicon-info-sign space-actions" title="Visualizza il dettaglio del Pagamento" (click)="onOpenDetail(payment)"></span>
              <span *ngIf="!hasRicevuta(payment)" class="glyphicon glyphicon-download-alt" title="Scarica il PDF dell'Avviso di Pagamento" (click)="downloadAvviso(payment.numeroAvviso)"></span>
              <span *ngIf="hasRicevuta(payment)" class="glyphicon glyphicon-download-alt space-actions" title="Scarica l'XML della Ricevuta di Pagamento" (click)="downloadRicevuta(payment.codiceCRS,true,'XML')"></span>
              <span *ngIf="hasRicevuta(payment)" class="glyphicon glyphicon-save-file" title="Scarica il PDF della Ricevuta di Pagamento" (click)="downloadRicevuta(payment.id,true,'PDF')"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-pagination">
    <app-pagination
    [resetCurrentPage]="resetCurrentPage"
    [totalItems]="payments != undefined ? payments.length : 0"
    (refreshEvent)="onRefresh($event)">
    </app-pagination>
  </div>

</div>

<div class="row" *ngIf="(payments == undefined || payments.length == 0) && hasSearched">
  <div class="col-sm-12 no-result">
    La ricerca dei pagamenti non ha ottenuto risultati
  </div>
</div>
